export default "__VITE_ASSET__oP0xBAiM__"